import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { coverTypePost } from "../../store/coverType/actions";
export var useCoverTypePost = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePostCoverType: (_a = state.CoverType.responsePostCoverType) === null || _a === void 0 ? void 0 : _a.data,
            errorPostCoverType: state.CoverType.errorPostCoverType,
            loadingPostCoverType: state.CoverType.loadingPostCoverType,
        });
    }), responsePostCoverType = _a.responsePostCoverType, errorPostCoverType = _a.errorPostCoverType, loadingPostCoverType = _a.loadingPostCoverType;
    useEffect(function () {
        console.log('useCoverTypePost', bodyRequest);
        if (trigger) {
            dispatch(coverTypePost(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePostCoverType: responsePostCoverType,
        errorPostCoverType: errorPostCoverType,
        loadingPostCoverType: loadingPostCoverType,
    };
};
